import React from "react";

const ChipReporte = ({ entregado }) => (
  <span className={entregado ? 'esen-chip esen-chip--success' : 'esen-chip esen-chip--neutral'}>
    <i className={entregado ? 'fa fa-check-circle' : 'fa fa-minus-circle'} aria-hidden="true"></i>
    {entregado ? 'Sí' : 'No'}
  </span>
);

const CarPracticasProfesionales = ({ datos }) => {
  const { empresa, inicio, fin, reporte_empresa, reporte_alumno } = datos;
  const empresaOk = reporte_empresa === 1;
  const alumnoOk = reporte_alumno === 1;
  return (
    <tr>
      <td><b>{empresa}</b></td>
      <td>{inicio}</td>
      <td>{fin}</td>
      <td><ChipReporte entregado={empresaOk} /></td>
      <td><ChipReporte entregado={alumnoOk} /></td>
    </tr>
  );
};

export default CarPracticasProfesionales;
